
<div class="facebook-post">
    <div class="post-title">
        <a class="profile-picture" target="_blank" [attr.href]="post.from.link||post.permalink_url">
            <img [attr.src]="post.from.picture||post.picture" alt="post">
        </a>
        <div class="post-content">
            <a place target="_blank" [attr.href]="post.from.link||post.permalink_url">
                {{post.from.name}}
            </a>
            <div class="post-message" *ngIf="post.message">
                {{post.message&&(post.message.length > messageLength) ? post.message.substr(0, messageLength) + '...' : post.message}}
                <a *ngIf="post.message&&(post.message.length > messageLength)" target="_blank" [attr.href]="post.permalink_url">READ MORE</a>
            </div>
            <div class="post-message" *ngIf="!post.message&&post.story">
                {{post.story}}
            </div>
        </div>
    </div>

    <a [attr.href]="post.permalink_url" target="_blank">
        <img class="post-img" *ngIf="!!post.full_picture" [attr.src]="post.full_picture" alt="facebook post">
    </a>
    <div class="post-footer">
        <div>{{post.updated_time | date: 'MMM, d \'at\' h:mm a'}}</div>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/facebook.post/facebook.post.component.html